// Analytic critically damped spring: no overshoot or frame-rate-dependent stepping.
export function advanceFactoryView(state, target, delta) {
  const frequency = 8
  const offset = state.value - target
  const momentum = state.velocity + frequency * offset
  const decay = Math.exp(-frequency * Math.max(0, delta))
  return {
    value: target + (offset + momentum * delta) * decay,
    velocity: (state.velocity - frequency * momentum * delta) * decay,
  }
}
